<!--
    描述：审核待办  --  开票 电子发票审核
    时间：2020-12-23
    Created by ws
    LastEditTime: 2022-4-21 16:25:52
    LastEditors: 钱磊
-->
<template>
	<div class="invoice-main">
		<h3 class="header text-overflow mt15">
			电子发票办理流程
			<span class="is-check" v-if="mode && mode === 'view'">（ ✔ 已审核 ）</span>
		</h3>

		<div class="container">
			<p class="point">
				温馨提示：企业新办电子发票首年2000元，次年开始1600元/年（含设备托管及维护费，详见：企业电子发票合同）
			</p>
			<div class="flow-container">
				<div class="flow-box">
					<div class="title">1. 资料准备</div>
					<div class="content">
						<p>1.企业公章</p>
						<p>2.发票专用章</p>
						<p>3.金税盘或税控盘营业执照复印件加盖公章</p>
						<p>4.办理人身份证</p>
					</div>
				</div>
				<div class="flow-box">
					<div class="title">2. 合同签约</div>
					<div class="content">
						<p>1.联系平台客服：0551-65770401</p>
						<p>2.百旺电子发票对接人：18010882821（张经理）</p>
						<p>3.完成合同签约</p>
					</div>
				</div>
				<div class="flow-box">
					<div class="title">3. 办理税盘</div>
					<div class="content">
						<p>1.企业自行到所在地税务局申办</p>
						<p class="pdl10">
							&nbsp;百旺税盘（具体办理流程见当地税务局规定）
						</p>
						<p class="pdl10">备注：航信税盘需要更换为百旺税盘</p>
					</div>
				</div>
				<div class="flow-box">
					<div class="title">4. 税盘上架</div>
					<div class="content">
						<p>1.邮寄税盘至百旺税盘托管中心</p>
						<p class="pdl10">邮寄地址：暂无</p>
						<p>2.百旺公司提供服务账号至能工社-安招采平台</p>
					</div>
				</div>
				<div class="flow-box">
					<div class="title">5. 完成办理</div>
					<div class="content">
						<p>1.企业完成电子发票办理</p>
					</div>
				</div>
			</div>
			<div class="note">
				注：新企业在办理发票领购簿时
				<p>
					1、由法人亲自办理：(1) 法人身份证原件及复印件(复印件加盖公章、发票专用章); (2) 营业执照副本原件(三证合一)及复印件(盖公章)
				</p>
				<p>2、由经办人亲自办理：</p>
				<p class="text-indent">(1) 法人身份证复印件(加盖公章);</p>
				<p class="text-indent">
					(2) 营业执照副本原件(三证合一)及复印件(加盖公章);
				</p>
				<p class="text-indent">
					(3) 经办人身份证验原件，收复印件(加盖公章、发票专用章);
				</p>
				<p class="text-indent">
					(4) 购票员委托书(咨询台领取，需法人亲笔签名或盖法人私章，并加盖公章)
				</p>
			</div>

			<div class="sub-title">办理人联系信息</div>
			<div class="form-container">
				<el-form ref="invoice-form" :model="invoiceForm" size="small" label-width="140px">
					<el-row>
						<el-col :span="8">
							<el-form-item label="企业名称：">{{ companyName }}</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="统一社会信用代码证：">{{ invoiceForm.creditCode }}</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<el-form-item label="办理人姓名：">{{ invoiceForm.userName }}</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="办理人身份证号：">{{ invoiceForm.idCard }}</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<el-form-item label="办理人手机号：">{{ invoiceForm.phone }}</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="地址：">{{ invoiceForm.address }}</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>

			<template v-if="mode === 'view'">
				<div class="sub-title" v-if="this.tabNum == '1'">税控盘信息</div>
				<div class="form-container" v-if="this.tabNum == '1'">
					<el-form ref="invoice-form" :model="addForm" size="small" label-width="140px">
						<el-row>
							<el-col :span="8">
								<el-form-item label="纳税人名称：">{{ addForm.sname }}</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="纳税人识别号：">{{ addForm.identifyNo }}</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<el-form-item label="地址：">{{ addForm.address }}</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="电话：">{{ addForm.phone }}</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<el-form-item label="开户行：">{{ addForm.bank }}</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="银行账号：">{{ addForm.account }}</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<el-form-item label="税控设备编号：">{{ addForm.deviceNo }}</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="开票终端标识：">{{ addForm.tag }}</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<el-form-item label="纳税人类型：">{{ addForm.type | TenantTpye(addForm.type) }}</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="税率：">{{ addForm.taxFileSname }}</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</template>

			<div class="footer" v-if="!mode">
				<el-button size="small" class="btn cancel-btn mr10" @click="noPass">不通过</el-button>
				<el-button size="small" class="btn btn-blue" @click="doCheck">审核</el-button>
			</div>
		</div>

		<!-- 弹窗 -->
		<el-dialog class="normal-dialog" :visible.sync="dialogObj.show" title="办理" center top="8vh" width="1000px">
			<el-form ref="addForm" :model="addForm" size="small" label-width="130px" :rules="addRules">
				<el-divider content-position="left">纳税人信息</el-divider>
				<el-row>
					<el-col :span="11">
						<el-form-item label="纳税人名称：" prop="sname">
							<el-input v-model="addForm.sname" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="1">
						<el-form-item label="纳税人识别号：" prop="identifyNo">
							<el-input v-model="addForm.identifyNo" disabled placeholder="请输入" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="地址：" prop="address">
							<el-input v-model="addForm.address" :disabled="isDisabled" placeholder="请输入" maxlength="80"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="1">
						<el-form-item label="电话：" prop="phone" :rules="phoneRule">
							<el-input v-model="addForm.phone" :disabled="isDisabled" placeholder="请输入" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="11">
                        <el-form-item label="业务类型：" prop="appKey">
                            <el-input
                                v-model="addForm.appKey"
                                :disabled="isDisabled"
                                placeholder="请输入"
                                maxlength="100"
                            ></el-input>
                        </el-form-item>
                    </el-col> -->
					<el-col :span="11">
						<el-form-item label="联系方式：" prop="contacts">
							<el-input v-model="addForm.contacts" :disabled="isDisabled" placeholder="请输入邮箱或手机号" maxlength="30"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="11" :offset="1">
						<el-form-item label="开户行：" prop="bank">
							<el-input v-model="addForm.bank" :disabled="isDisabled" placeholder="请输入" maxlength="100"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="银行账号：" prop="account">
							<el-input v-model="addForm.account" :disabled="isDisabled" placeholder="请输入" maxlength="30"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="left">设备 （备注：以下信息需要联系百旺获取）</el-divider>
				<el-row>
					<el-col :span="11">
						<el-form-item label="税控设备编号：" prop="deviceNo">
							<el-input v-model="addForm.deviceNo" :disabled="isDisabled" placeholder="请输入" maxlength="18"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="1">
						<el-form-item label="开票终端标识：" prop="tag">
							<el-input v-model="addForm.tag" :disabled="isDisabled" placeholder="请输入" maxlength="50"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="appkey：" prop="appKey">
							<el-input v-model="addForm.appKey" :disabled="isDisabled" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="left">税率</el-divider>
				<el-row>
					<el-col :span="11">
						<el-form-item label="纳税人类型：" prop="type">
							<el-radio-group v-model="addForm.type" :disabled="isDisabled" @change="radioChange">
								<el-radio :label="0">一般纳税人</el-radio>
								<el-radio :label="1">小规模纳税人</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="1">
						<el-form-item label="税档：" prop="taxFile">
							<el-checkbox-group v-if="addForm.type == 0" v-model="addForm.taxFile" :disabled="isDisabled">
								<el-checkbox v-for="(item, index) in normalTaxList" :key="'taxFile' + index" :label="item.value">{{
									item.label
								}}</el-checkbox>
							</el-checkbox-group>
							<el-checkbox-group v-else v-model="addForm.taxFile" :disabled="isDisabled">
								<el-checkbox v-for="(item, index) in smallTaxList" :key="'taxFile' + index" :label="item.value">{{
									item.label
								}}</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-divider content-position="left">经营范围</el-divider>
				<el-row>
					<el-form-item prop="busSope" label-width="20px">
						<el-tree
							ref="tree"
							:data="treeData"
							:disabled="isDisabled"
							:expand-on-click-node="false"
							:highlight-current="true"
							:props="defaultProps"
							node-key="value"
							default-expand-all
							:default-checked-keys="treeDefaultCheckedKey"
							show-checkbox
						></el-tree>
					</el-form-item>
				</el-row>
			</el-form>
			<!-- footer 组件 -->
			<div slot="footer" class="dialog-footer text-center">
				<el-button size="small" class="btn" @click="dialogObj.show = false">取 消</el-button>
				<el-button type="primary" size="small" class="btn btn-blue" :loading="dialogObj.btnLoading" @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getCascadeByValue, getBusScopeTreeList, auditSubmit } from 'api/modules/invoice'
import { getRecordDetail} from 'api/modules/audit'
export default {
	props: {
		// form 对象
		formObj: {
			type: Object,
			default: () => {
				return {}
			}
		},
		// form 对象
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		let phoneReg = (rule, value, callback) => {
			// eslint-disable-next-line no-useless-escape
			let reg = /(^0\d{2,3}\-\d{7,8}$)|(^1[3|4|5|6|7|8][0-9]{9}$)/
			if (reg.test(value)) {
				callback()
			} else {
				return callback(new Error('格式不正确'))
			}
		}
		return {
			invoiceForm: {
				sname: '', // 企业名称
				creditCode: ''
			},
			dialogObj: {
				show: false,
				btnLoading: false
			},
			countdown: 3,
			// 新增弹框
			addForm: {
				tenantId: '', //纳税人id
				sname: '', //纳税人名称
				identifyNo: '', //纳税人识别号
				address: '', //地址
				phone: '', //电话
				bank: '', //开户行
				account: '', //银行账号
				contacts: '', // 联系方式
				appKey: '', //银行账号
				deviceNo: '', //税控设备编号
				tag: '', //开票终端标识
				type: 0, //纳税人类型
				taxFile: [], //税档
				busSope: [] //经营范围
			},
			// eslint-disable-next-line no-undef
			addRules: bmElementFormRules([
				{ keyName: 'tenantId', validatorName: 'required', tip: '' },
				{ keyName: 'identifyNo', validatorName: 'required', tip: '' },
				{ keyName: 'address', validatorName: 'required', tip: '' },
				{ keyName: 'bank', validatorName: 'required', tip: '' },
				{ keyName: 'account', validatorName: 'required', tip: '' },
				{ keyName: 'appKey', validatorName: 'required', tip: '' },
				{ keyName: 'tag', validatorName: 'required', tip: '' },
				{ keyName: 'deviceNo', validatorName: 'required', tip: '' },
				{ keyName: 'type', validatorName: 'select', tip: '' },
				{ keyName: 'taxFile', validatorName: 'select', tip: '' }
			]),
			phoneRule: [
				{ required: true, message: '不能为空', trigger: 'blur' },
				{ validator: phoneReg, trigger: 'blur' }
			],
			isDisabled: false,
			normalTaxList: [], //一般纳税人税档
			smallTaxList: [], //小规模纳税人税档
			treeData: [], // 经营范围数据
			defaultProps: {
				children: 'children',
				label: 'sname'
			},
			treeDefaultCheckedKey: [],
			tabNum: ''
		}
	},
	filters: {
		TenantTpye(val) {
			//判断纳税人类型
			if (val == 0) {
				return '一般纳税人'
			} else {
				return '小规模纳税人'
			}
		}
	},
	created() {
		if (this.rowId && this.rowId !== '') {
			this.tabNum = JSON.parse(this.$getSessionItem('activeTab'))
			this.getInfo()
		} else {
			this.goBack()
		}
		// 获取所有税率
		this.getCascadeByValue()
		// 获取所有经营范围
		this.getBusScopeTreeList()
	},
	methods: {
		// 获取申请的信息
		getInfo() {
			getRecordDetail({ recordId: this.rowId, id: this.rowId })
				.then((res) => {
					if (res.operationCode === 1 && res.data) {
						this.invoiceForm = res.data.invoiceApply
						this.addForm.tenantId = res.data.invoiceApply.tenantId
						this.addForm.identifyNo = res.data.invoiceApply.creditCode
						this.addForm.sname = this.companyName
						if (this.mode === 'view' && this.rowData.status != 2) {
							if (res.data.invoice) {
								this.addForm = res.data.invoice
							}
						}
					}
				})
				.catch((err) => {})
		},

		// 获取开票的信息 （查看模式下）
		getTaxedInfo() {
			getRecordDetail({ recordId: this.rowId, id: this.rowId })
				.then((res) => {
					console.log(res)
					if (res.operationCode === 1) {
						this.addForm = res.data.invoiceApply
					}
				})
				.catch((err) => {})
		},

		// 获取所有税率
		getCascadeByValue() {
			getCascadeByValue({
				code: '1008'
			}).then((d) => {
				if (d.operationCode == 1) {
					this.smallTaxList = d.data[0].children
					this.normalTaxList = d.data[1].children
				}
			})
		},

		// 获取所有经营范围
		getBusScopeTreeList() {
			getBusScopeTreeList().then((d) => {
				if (d.operationCode == 1) {
					this.treeData = d.data
					if (this.isDisabled) {
						this.treeData.forEach((item) => {
							let children = item.children
							children.forEach((x) => {
								x.disabled = true
							})
							item.disabled = true
						})
					}
				}
			})
		},

		// 纳税人类型切换
		radioChange() {
			this.addForm.taxFile = []
		},

		// 不通过
		noPass() {
			this.$confirm('确认要驳回该用户的电子发票办理申请吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					auditSubmit({
						id: this.rowId,
						busId: this.rowData.busId,
						busType: this.rowData.busType,
						status: 2 //1审核通过，2审核不通过
					}).then((res) => {
						this.$message.success('操作完成！')
						this.goBack()
					})
				})
				.catch(() => {
					this.$message.info('已取消操作！')
				})
		},

		// 点击返回
		goBack() {
			this.dialogObj.show = false
			this.$router.push({ path: '/audit-affairs-new' })
		},

		// 点击办理审核
		doCheck() {
			this.dialogObj.show = true
		},

		// 确认审核
		doSave() {
			this.dialogObj.btnLoading = true
			if (this.addForm.taxFile.length < 1) {
				this.$message.error('请选择税率！')
				setTimeout(() => {
					this.dialogObj.btnLoading = false
				}, 2000)
				return
			} else {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						let params = Object.assign({}, this.addForm)
						// 获取经营范围所有选中的，分割成字符串
						let res = this.$refs.tree.getCheckedNodes()
						let arr = []
						res.forEach((x) => {
							arr.push(x.value)
						})
						arr = arr.join(',')
						params.busSope = arr
						// 税率
						params.taxFile = params.taxFile.join(',')

						// 保存开票设置
						auditSubmit({
							id: this.rowId,
							addForm: params,
							busId: this.rowData.busId,
							busType: this.rowData.busType,
							status: 1 //1审核通过，2审核不通过
						})
							.then((d) => {
								this.dialogObj.btnLoading = false
								if (d.operationCode == 1) {
									this.$message.success('办理成功！')
									this.goBack()
								}
							})
							.catch((err) => {
								setTimeout(() => {
									this.dialogObj.btnLoading = false
								}, 2000)
							})
					}
				})
			}
		},

		// 打开消息弹窗
		openDialog() {
			this.dialogObj.show = true
			this.countdown = 3
			setInterval(() => {
				this.countdown--
				if (this.countdown === 0) {
					this.dialogObj.show = false
					this.goBack()
				}
			}, 1000)
		}
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		// 是否是查看模式
		mode() {
			return this.$route.query.mode
		},

		// 企业ID
		rowId() {
			return this.$route.query.id
		},

		// 企业名称
		companyName() {
			return decodeURI(this.$route.query.companyName)
		}
	}
}
</script>

<style scoped lang="less">
.invoice-main {
	height: 98%;
	background-color: #fff;

	.is-check {
		color: #4caf50;
	}

	.header {
		line-height: 40px;
		font-size: 14px;
		background-color: #dcdfe6;
		padding: 0 20px;
		color: #202020;
	}

	.container {
		height: calc(~'100% - 40px');
		padding: 20px;
		overflow-y: auto;

		.point {
			line-height: 35px;
			background-color: #ecf0fb;
			color: #2671cc;
			font-size: 12px;
			border: 1px solid #abc0fa;
			padding: 0 15px;
		}

		.flow-container {
			margin-top: 20px;
			text-align: center;
		}

		.note {
			padding: 10px 15px;
			font-size: 12px;
			color: #666;
			background-color: #f4f7fa;
			line-height: 24px;
		}

		.sub-title {
			font-size: 14px;
			color: #202020;
			line-height: 40px;
			margin-top: 10px;
		}

		.footer {
			width: 100%;
			margin-top: 30px;
			text-align: center;
		}
	}

	.flow-box {
		position: relative;
		display: inline-block;
		vertical-align: middle;
		width: 300px;
		height: 180px;
		font-size: 12px;
		border-top: 4px dotted #dcdcdc;
		margin-bottom: 20px;

		&:before {
			content: '';
			position: absolute;
			left: 50%;
			top: -2px;
			background: url('../../../../assets/images/account-arrow.png') no-repeat;
			width: 12px;
			height: 14px;
			transform: translate(-50%, -50%);
		}

		.title {
			width: 100%;
			height: 81px;
			line-height: 88px;
			text-align: center;
			color: #fff;
			background: url('../../../../assets/images/account-bubble.png') no-repeat;
			background-position: center center;
		}

		.content {
			padding: 6px 10px;
			line-height: 22px;
			text-align: left;
		}
	}

	.form-container {
		/deep/ .el-form-item__label {
			font-size: 12px;
		}

		/deep/ .el-form-item__content {
			font-size: 12px;
			color: #666;
		}

		/deep/ .el-input {
			font-size: 12px;
		}

		/deep/ .el-form-item {
			margin-bottom: 0;
		}
	}

	.text-indent {
		text-indent: 2em;
	}
}
</style>
